import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import BrandProfile from '../components/BrandProfile';
import SettingsSidebar from 'modules/settings/SettingsSidebar';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';

import { t } from 'utils/language';
import { getBrandProfileId } from 'utils/organization';

import type { BrandProfile as BrandProfileType, Organization } from 'types';
import type { Dispatch } from 'redux';

type StateProps = {
  currentOrganization: Organization,
  profile: BrandProfileType
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch
} & StateProps;

const BrandProfilePage: React.FunctionComponent<Props> = (
  {
    profile,
    currentOrganization
  }: Props
) => {
  const brandProfileId = getBrandProfileId(currentOrganization);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {!!brandProfileId && (
        <Page
          documentTitle={t('brand_profile_title', { brandName: profile.name })}
        >
          <SidebarPage
            scrollable
            sidebarWidth="narrow"
            sidebarContent={<SettingsSidebar />}
          >
            <BrandProfile
              key={brandProfileId}
              profileId={brandProfileId}
              coverImageType="cover-medium"
            />
          </SidebarPage>
        </Page>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ brandProfile, organizations }): StateProps => ({
  profile: brandProfile.profile,
  currentOrganization: organizations.currentOrganization
});

export default connect(mapStateToProps)(BrandProfilePage);
